<template>
  <footer class="recaptcha-footer-text">
    Protegido por reCAPTCHA, sujeito à
    <a href="https://policies.google.com/privacy" target="_blank"
      >Política de Privacidade</a
    >
    e aos
    <a href="https://policies.google.com/terms" target="_blank"
      >Termos de Serviço</a
    >
    do Google.
  </footer>
</template>

<script>
export default {
  name: "RecaptchaLayout",
};
</script>

<style scoped>
.recaptcha-footer-text {
  background-color: transparent;

  width: 100%;
  text-align: center;
  padding: 15px;
  font-size: 0.85rem;
}
</style>
